/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AirplaneIcon = ({ width = 24, height = 24, hidden = false, title = 'Airplane' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m34.254.34-.655.129a9.579 9.579 0 0 0-4.939 2.628L22.238 9.52 3.12 4.305a2 2 0 0 0-1.94.516L0 6l16.558 9.2-2.96 2.96a8.47 8.47 0 0 0-.874 1.024l-3.344 4.62L1 23.429l-1 1 6.368 3.537-2.024 2.796a.64.64 0 0 0 .894.894l2.796-2.024L11.57 36l1-1-.375-8.38 4.62-3.344a8.47 8.47 0 0 0 1.024-.874l2.96-2.96L30 36l1.18-1.18a2 2 0 0 0 .515-1.94L26.48 13.762l6.421-6.422a9.583 9.583 0 0 0 2.63-4.94l.127-.654A1.198 1.198 0 0 0 34.254.341Z"
    />
  </svg>`;
};
